import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import HearMeItem from './HearMeItem';
import Loading from '../common/Loading.js';
import ErrorMessage from '../common/ErrorMessage';

class HearMe extends React.Component {
    constructor(props, context) {
        super(props, context);
     }

    componentWillMount() {  
        if((!this.props.artist.Music && !this.props.artist.MusicStatus) || this.props.artist.MusicStatus === 'FAILED') {
            this.props.actions.getMusic(this.props.artist.Username);
        }
    }

    /*componentWillUpdate(nextProps) {           
        console.log('Music status: ' + nextProps.artist.MusicStatus); 
        if(this.props.activeProfile !== nextProps.activeProfile && nextProps.artist.MusicStatus !== 'LOADING') {
            console.log('getting music...');
            this.props.actions.getMusic(nextProps.artist.Username);          
        }     
    }*/

    render() {
        const artist = this.props.artist;
        const actions = this.props.actions;
        return (
            artist.MusicStatus === 'FAILED' ?
                <ErrorMessage error="Sorry, something went wrong! Unable to load tracks." />
                :
                artist.Music && artist.Music.length > 0 ?
                    <div id="ulHearMe">
                        {artist.Music.map((track) => <HearMeItem key={track.ID} track={track} actions={actions} showArtistName={artist.RoleType === 'Fan'} />)}
                    </div>
                    :
                    (artist.MusicStatus == 'LOADING' ?
                            <Loading /> : <p className="biotext">Coming soon...</p>)
        );
    }
}

HearMe.propTypes = {
    artist: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default HearMe;